import { render } from "./Active_bid.vue?vue&type=template&id=7d712de1"
import script from "./Active_bid.vue?vue&type=script&lang=js"
export * from "./Active_bid.vue?vue&type=script&lang=js"
script.render = render

export default script